import React, { useEffect, useState } from "react";

const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
// const domainpath = "http://localhost:5000";

const Blog = () => {
  const [AllBlogs, setAllBlogs] = useState([]);
  const url = window.location.href;

  function extractHost(url) {
    try {
      const urlObject = new URL(url);
      return urlObject.host;
    } catch (error) {
      console.error(`Invalid URL: ${url}`);
      return null;
    }
  }
  const DomainPath = extractHost(url);

  useEffect(() => {
    async function GetAllBlogs() {
      try {
        const response = await fetch(`${domainpath}/api/blog`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        if (data?.blogs) {
          setAllBlogs(data.blogs);
        } else {
          console.warn("No blogs found in response");
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    }

    GetAllBlogs();
  }, [domainpath]);
  function extractFirst30Words(htmlContent) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent;
    let wordCount = 0;
    const first30WordsHTML = [];

    function traverseNodes(node) {
      if (wordCount >= 30) return;
      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.trim().split(/\s+/);
        for (const word of words) {
          if (wordCount < 30) {
            first30WordsHTML.push(word);
            wordCount++;
          }
        }
      } else if (
        node.nodeType === Node.ELEMENT_NODE &&
        node.tagName.toLowerCase() !== "img"
      ) {
        const clonedNode = node.cloneNode(false);
        clonedNode.style.cssText = node.style.cssText;
        first30WordsHTML.push(clonedNode.outerHTML);
        node.childNodes.forEach((child) => traverseNodes(child));
        first30WordsHTML.push(`</${clonedNode.tagName.toLowerCase()}>`);
      }
    }

    tempElement.childNodes.forEach((child) => traverseNodes(child));
    return first30WordsHTML.join(" ").replace(/\s+/g, " ").trim();
  }

  return (
    <>
      <section className="breadcumb no-bg">
        <div className="mainbreadcumb ">
          <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold text-center mb-4">Blogs</h1>
            {AllBlogs.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {AllBlogs.map((item) => (
                  <div
                    key={item.id}
                    className="border p-4 rounded-lg shadow-md cursor-pointer"
                    onClick={() =>
                      (window.location.href = `/blog/${item.slug}`)
                    }
                  >
                    <div className="w-full h-40 overflow-hidden rounded-md">
                      <img
                        src={
                          item.featured_image && item.featured_image !== "null"
                            ? domainpath + item.featured_image
                            : "./img/collections/coll-item-3.jpg"
                        }
                        onError={(e) => {
                          e.target.onerror = null; // Prevents infinite loop if default image also fails
                          e.target.src = "./img/collections/coll-item-3.jpg"; // Set default image on error
                        }}
                        alt={item.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="mt-3">
                      <h2 className="text-xl font-semibold">{item.title}</h2>
                      {item.html && (
                        <p
                          className="text-gray-600"
                          dangerouslySetInnerHTML={{
                            __html: extractFirst30Words(item.html),
                          }}
                        ></p>
                      )}
                    </div>
                    <div className="mt-2 text-blue-500 font-medium">
                      Read More
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-gray-500">
                There are no blogs found.
              </p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
